<template>
  <div class="tmp-item">
    <div class="tmp-item-icon">
      <i :class="icon" />
    </div>
    <div class="tmp-item-text">
      {{ cnName }}
    </div>
    <!-- <el-tooltip
      v-if="tooltip"
      class="item"
      effect="dark"
      :content="tooltip"
      placement="top-start"
    >
      <i class="el-icon-question" />
    </el-tooltip> -->
  </div>
</template>
<script>
export default {
  name: 'FormTmpItem',
  props: {
    cnName: {
      type: String
    },
    tooltip: {
      default: '',
      type: String
    },
    icon: {
      default: 'el-icon-s-tools',
      type: String
    }
  },
  data () {
    return {}
  },
  watch: {},
  created () {},
  methods: {}
}
</script>

<style scoped lang="scss">
.tmp-item {
  // display: flex;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  width: 70px;
  padding: 5px;
  margin-right: 16px;
  background: #f0f2f5;
  margin-bottom: 16px;
  cursor: pointer;
  border-radius: 3px;
  &:hover {
    background: #f2fbff;
    color: #0171c2;
  }
  .tmp-item-icon {
    line-height: 40px;
    height: 40px;
    font-size: 30px;
  }
  .tmp-item-text {
    height: 20px;
    line-height: 20px;
  }
}
</style>
